import { Box, Stack } from "@mui/material";

import Application from "../../../components/application";
import MyPanel from "../../../components/myPanel";
import MyLabel from "../../../components/myLabel";
import MyInput from "../../../components/myInput";
import MyButton from "../../../components/myButton";
import { useNavigate, useParams } from "react-router-dom";
import useCursoState from "../../../hooks/useCursoState";
import { useContext, useEffect } from "react";
import MyLoading from "../../../components/myLoading";
import { AuthContext } from "../../../contexts/auth";
import TELAS from "../../../constants/telas";
import TELA_ACOES from "../../../constants/telaAcoes";
import permissaoTelas from "../../../utils/permissaoTelas";


// permissão para telas
const PAGINA = {
    aplicacao: 'SisPalo - Colaborador',
    funcionalidade: 'Cursos',
    tela: TELAS.CURSOS,
    acoes: [TELA_ACOES.Incluir,TELA_ACOES.Alterar]
}


const Curso = () => {
    const navigate = useNavigate()
    const { id } = useParams()
    const {permissaoUsuario} = useContext(AuthContext); /* permissão para telas*/    
    
    const states = useCursoState()

    useEffect(()=>{
        /* permissão para telas*/
        if (permissaoTelas(permissaoUsuario, TELA_ACOES.Incluir, PAGINA)
        || permissaoTelas(permissaoUsuario, TELA_ACOES.Alterar, PAGINA)){
            if (id && id !== ''){
            states.submit.set(id)
            }
        }
        else {
            navigate('/gestor/dashboard')
        }
    }, [])
    
    return (
   
        <Application>
            <MyPanel>
                <MyLoading render={states.submit.value}/>
                <Stack spacing={5}>
                    <MyLabel component='h1' text = {`Curso: ${states.nome.value}`}/>
                    <Box>
                        <Box >
                            <MyInput sx={{width:'100%'}} size="small" label='Nome' type='text' value={states.nome.value} onChange={(e)=>states.nome.set(e.target.value)}/>
                        </Box>
                        <Box sx={{display:'flex', marginTop: 2 , justifyContent:'space-between'}}>
                            <MyButton color='warning' onClick={()=> navigate('/gestor/cursos')} variant='contained' text='Cancelar'/>
                            <MyButton sx={{marginRight:1}} color='success' onClick={()=> states.curso.value ? states.cursoPut.set() : states.cursoPost.set()} variant='contained' text={states.curso.value ? 'Alterar' : 'Salvar'} />
                        </Box>
                    </Box>
                </Stack>
            </MyPanel>
        </Application>
   
    )
}

export default Curso;